export const TEXT = 'Нажимая «Принять все файлы cookie», вы соглашаетесь с тем, что Московский Центр Качества Образования может хранить файлы cookie на вашем устройстве и раскрывать информацию в соответствии с нашей Политикой использования файлов cookie.';
export const COOKIE_KEY_PREFIX = 'cookie_accepted';
